import React from 'react';
import SalesScoreboard from './SalesScoreboard';

export default function SalesScoreboardPage({ user, managedOwner }) {
  return <SalesScoreboard user={user} managedOwner={managedOwner} />;
}
